import { Box, FileUpload, FileUploadRoot, FileUploadTrigger, } from "@chakra-ui/react"
import { Button } from "@/components/ui/button";
import Icon, { Icons } from "./Icons";
import useToast from "./hooks/useToast";

const ACCEPTED_EXTENSIONS = [
    ".jpg", ".jpeg", ".png", ".gif", ".bmp", ".webp", ".svg", ".tiff", ".tif",
    ".pdf", ".txt", ".csv", ".doc", ".docx", ".xls", ".xlsx", ".ppt", ".pptx", ".odt", ".ods", ".odp",
    ".mp4", ".mov", ".avi", ".mkv", ".webm",
];

const ACCEPTED_FILE_TYPES = ACCEPTED_EXTENSIONS.join(",");

const Fileupload = ({
    title,
    disabled = false,
    onChange
}: {
    title: string,
    disabled?: boolean,
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void,
}) => {
    const toast = useToast();
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file) {
            const ext = file.name.includes('.') ? '.' + file.name.split('.').pop()!.toLowerCase() : '';
            if (!ACCEPTED_EXTENSIONS.includes(ext)) {
                event.target.value = '';
                toast("Unsupported file type", `Please select a file type that is one of the following: ${ACCEPTED_EXTENSIONS.join(", ")}`, "error");
                return;
            }
        }
        onChange(event);
    };

    return (
        <Box>
            <FileUploadRoot disabled={disabled} onChange={handleChange} accept={ACCEPTED_FILE_TYPES}>
                <FileUpload.HiddenInput />
                <FileUploadTrigger asChild>
                    <Button>
                        <Icon icon={Icons.upload} />
                        {title}
                    </Button>
                </FileUploadTrigger>
            </FileUploadRoot>
        </Box>
    )
}

export default Fileupload;